/**
 * WhatsApp Mask
 */
	import VMasker from 'vanilla-masker';

	const formMaskPhone = document.querySelectorAll('[type="tel"]')

	function inputPhoneHandler(masks, max, event) {
		var c = event.target
		var v = c.value.replace(/\D/g, '')
		var m = c.value.length > max ? 1 : 0
		VMasker(c).unMask()
		VMasker(c).maskPattern(masks[m])
		c.value = VMasker.toPattern(v, masks[m])
	}

	const formMasksPhone = ['(99) 9999-9999', '(99) 99999-9999']

	if (formMaskPhone) {
		formMaskPhone.forEach(e => {
			VMasker(e).maskPattern(formMasksPhone[0])
			e.addEventListener('input', inputPhoneHandler.bind(undefined, formMasksPhone, 14), false)
		})
	}
